var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"active-challenge-router"},[(_vm.isChallengeFinished)?_c('active-challenge-summary'):(_vm.isAuthenticatedRoute)?_c('active-challenge-dashboard'):_c('active-challenge-dashboard-non-customer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }